import Fuse from 'fuse.js';
import { debugLog } from '../../debug-log';

export const identifyDealership = async (
  dealer: string,
  dealershipLocation?: string,
  zipcode?: string,
) => {
  let dealershipName = dealer?.split('\n')[0]?.trim();

  dealershipName = dealershipName?.split(',')[0];

  let backEndUrl = `${process.env.SVELTE_APP_FE_REMOTE_URL}/api/mbdmbos`;

  if (dealershipName.toLowerCase().includes('s&g') && dealershipLocation) {
    const requestFilter = encodeURIComponent(
      `{"where":{"name":{"like":"%s&g%"}}}`,
    );
    const dealershipRequest = await fetch(
      `${backEndUrl}/dealerships?filter=${requestFilter}`,
      {
        headers: {
          Accept: 'application/json, text/plain',
          'Content-Type': 'application/json;charset=UTF-8',
          'X-Custom-Header': 'mb-cashback-2025-header',
        },
      },
    );
    const dealership = await dealershipRequest.json();

    const dealershipMatch = dealership.find((d: any) =>
      d.ort.toLowerCase().includes(dealershipLocation.toLowerCase()),
    );

    if (dealershipMatch) {
      return dealershipMatch;
    }
  }

  let dealership = [];

  let zipCode = null;
    if(!zipcode){
    debugLog({ dealer });
    const zipCodeMatch = dealer.match(/\b\d{5}\b/);
    zipCode = zipCodeMatch ? zipCodeMatch[0] : null;
  } else {
    zipCode = zipcode;
  }
  

  debugLog({ dealershipName,dealershipLocation });

  if (zipCode) {
    debugLog({ zipCode });
    const zipCodeFilter = encodeURIComponent(`{"where":{"plz":{"like":"${zipCode}"}}}`);
    const dealershipRequest = await fetch(
      `${backEndUrl}/dealerships?filter=${zipCodeFilter}`,
    );
    dealership = await dealershipRequest.json();

    debugLog({ dealership });
  }

  if (dealership.length > 1) {
    // (1) If not unique by zip code, filter by name
    // need to narrow down possible dealerships
    const fuse = new Fuse(
      dealership.map((d: any) => d.name),
      {
        includeScore: true,
      },
    );
    const rankedSearch = fuse.search(dealershipName);
    debugLog({ zipCodeMatch: dealership[rankedSearch[0]?.refIndex] });
    return dealership[rankedSearch[0]?.refIndex];
  } else if (dealership.length === 1) {
    // (2) If unique by zip code, return value

    debugLog({ zipCodeMatch: dealership[0] });
    return dealership[0];
  } else {
    const notUsedWords = [
      'AG',
      'GmbH',
      'KG',
      'LLC',
      'LLP',
      'Ltd',
      'Corp',
      'Inc',
      'Co',
      'Company',
      'Corporation',
      'Holdings',
      'Group',
      'Services',
      'International',
      'Trading',
      'Partners',
      'Enterprises',
      'Limited',
      'PLC',
      'S.A.',
      'B.V.',
      'N.V.',
      'Pty',
      'GmbH & Co. KG',
      'S.L.',
      'S.R.L.',
      'S.p.A.',
      'OÜ',
      'Oy',
      'AB',
      'AS',
      'NV',
      'SA',
      'SAS',
      'SARL',
      'K.K.',
      'Kabushiki Kaisha',
      'LLLP',
      'LP',
      'L.P.',
      'SPRL',
      'EURL',
      'BVBA',
      'GmbH & Co.',
      'KGaA',
      'OHG',
      'e.K.',
      'eG',
      'SCE',
      'SED',
      'SCA',
      'SASU',
      'SNC',
      'Ltda',
      'EIRL',
      'E.I.R.L.',
      'Autohaus',
      'Auto',
      'Motors',
      'Cars',
      'Dealership',
      'Automotive',
      'Center',
      'Sales',
    ];
    // (3) If not found by zip code, find by name
    const nameWords = dealershipName
      .split(' ')
      .filter((word) => word.length > 1 && !notUsedWords.includes(word))
      .map((word) => word.toLowerCase());
    const nameFilter = nameWords
      .map((word) => `{"name":{"like":"%25${encodeURIComponent(word)}%25"}}`)
      .join(',');

    const url = nameFilter
      ? `${backEndUrl}/dealerships?filter=${encodeURIComponent(`{"where":{"or":[${nameFilter}]}}`)}`
      : `${backEndUrl}/dealerships`;
    const dealershipRequestWithNameFilter = await fetch(url);
    const dealershipWithNameFilter =
      await dealershipRequestWithNameFilter.json();

    if (dealershipWithNameFilter.length == 1) {
      // (4) If unique by name, return value
      return dealershipWithNameFilter[0];
    } else if (dealershipWithNameFilter.length > 1) {
      // (5) If not unique by name, use Fuse.js to find the best match
      const fuse = new Fuse(dealershipWithNameFilter, {
        keys: ['name'],
        includeScore: true,
      });
      const rankedSearch = fuse.search(dealershipName);
      return rankedSearch[0]?.item;
    }
  }
};
